import { render, staticRenderFns } from "./ProductField.vue?vue&type=template&id=21a90ad6&scoped=true"
import script from "./ProductField.vue?vue&type=script&lang=js"
export * from "./ProductField.vue?vue&type=script&lang=js"
import style0 from "./ProductField.vue?vue&type=style&index=0&id=21a90ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a90ad6",
  null
  
)

export default component.exports